import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Customer} from "../../customer/customer.model";
import {Subscription} from "../../subscription/subscription.model";
import {Company, Contact} from "../../company/company.model";
import {Model} from "../../app.model";

@Component({
    selector: 'app-select-invoice-contact',
    templateUrl: './select-invoice-contact.component.html',
    standalone: false
})
export class SelectInvoiceContactComponent implements OnInit {
  @Input() public subscription: Subscription;
  @Input() public customer: Customer | Company;
  @Input() public historyBack?: boolean = true;
  @Output() public readonly selected = new EventEmitter<Contact>();
  @Output() public readonly back = new EventEmitter();

  public multiselectableContacts: { label: string; value: Contact }[] = [];
  public selectedContact: Contact;
  public contact: Contact;
  public isCreating = false;
  public isPC20CSP: boolean;

  constructor(
    private m: Model
  ) { }

  ngOnInit(): void {
    this.isPC20CSP = this.m.account.currentUser.companyIsPC20Csp;
    if (!this.customer.contacts || this.customer.contacts.length <= 0) {
      this.onAddContact();
      return;
    }
    if (this.subscription) {
      this.contact = this.customer.contacts.find(c => +c.id === this.subscription.subscription_customer_id)
    } else {
      this.contact = this.customer.contacts[0] ?? undefined;
    }

    this.selectedContact = this.contact;

    this.addToMultilist();
  }

  public onAddContact() {
    this.isCreating = true;
  }

  public onContactCreated(contact: Contact) {
    this.selectedContact = contact;
    this.customer.contacts.push(contact);
    this.addToMultilist();
    this.next();
  }

  public selectContact() {
    if (!this.selectedContact) return;
    this.next();
  }

  private next() {
    this.selected.emit(this.selectedContact);
  }

  private addToMultilist() {
    this.multiselectableContacts = this.customer.contacts.map(c => {
      return {
        label: this.isPC20CSP ? c.fullName : c.fullNameWithMail,
        value: c
      }
    });
  }


}
